"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkValidate = void 0;

var checkValidate = function checkValidate(value) {
  if (!value || value.length < 2) return false;
  return !/[0-9!"№;%:?*()_+=~[\]`@#$^&{},.<>/|\\']/.test(value);
};

exports.checkValidate = checkValidate;